import { mountComponent_footer } from "../../components/layout/footer";

(function ready(fn) {
    if (document.readyState !== "complete") {
        fn();
    } else {
        window.addEventListener("load", fn);
    }
})(() => {
    mountComponent_footer("site-footer-component");
});
